import React, { createContext } from 'react';

export const GameStatsContext = createContext();
